var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"timezone"},[_vm._v(" Timezone: "+_vm._s(_vm.timezone)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }